import { useMemo } from 'react'
import { useAdmin } from '../AdminContext'
import { SITE_URL } from '../../data/seo'
import { withSalonFooter } from '../../core/rules/mail'
import type { MailFrameContext } from '../newsletter/newsletterHtml'
import type { MailBrand } from '../../core/types/mail'

/** Het frame van elke mail: salongegevens uit het beheer, plus de huisstijl als die geladen is. */
export function useMailFrame(brand: MailBrand | undefined): MailFrameContext {
  const { site } = useAdmin()
  return useMemo(
    () => ({ siteUrl: SITE_URL, salonName: site.salon.name, salonAddress: site.salon.address, brand: brand && withSalonFooter(brand, site.salon) }),
    [site.salon, brand],
  )
}
